import * as React from "react";
import { Organization } from "../../organizations/types";
import ErrorMessage from "../../../components/ErrorMessage";

interface OwnProps {
  setCurrentOrg: (org: Organization) => void;
  currentOrganization: Organization | null;
  organizations: Organization[] | null;
}

type Props = OwnProps;

export default (props: Props) => {
  const { organizations, currentOrganization } = props;

  if (organizations && organizations.length > 0) {
    return (
      <>
        <div className="select-org-container">
          <div className="selections">
            <div className="bold mb-20">Which patient list would you like to view?</div>
            {organizations.map(o => (
              <button
                className={`mb-20 ${currentOrganization &&
                  currentOrganization.id === o.id &&
                  "selected"}`}
                key={o.id}
                onClick={() => props.setCurrentOrg(o)}
              >
                {o.name}
              </button>
            ))}
          </div>
        </div>
      </>
    );
  } else {
    return <ErrorMessage message="Could not find organizations for user" />;
  }
};
